module.exports = __webpack_public_path__ + "img/BTA.efac2237.svg";